export default __webpack_public_path__ + "static/media/18t.fff505bc.jpg";